import React, { useState } from 'react'
import { AutoComplete, Form, Input, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { RightOutlined } from '@ant-design/icons'
import { get } from '../../../../Common/api'
import { Color } from '../../../../Common/Color'
import { useForm } from 'antd/es/form/Form'

const highlight = (text, highlight) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
  return <span> {parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: Color.red } : {}}>
      {part}
    </span>)
  } </span>
}

const renderItem = (e, search) => ({
  value: `${e.normalized_name} ${e.zip_code}`,
  key: e.id,
  extra: e,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {highlight(e.normalized_name, search)}
      <span> {highlight(e.zip_code, search)} </span>
    </div>
  )
})

export default function MobileSearch () {
  const { t } = useTranslation()
  const [options, setOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState()
  const [loading, setLoading] = useState(false)
  const [form] = useForm()

  const onFinish = () => {
    if (selectedOption) {
      // Force browser navigation to set cookie
      window.location.href = `/results?lat=${selectedOption.lat}&long=${selectedOption.long}`
    } else {
      const inputValue = form.getFieldValue('search')
      window.location.href = `/results?q=${encodeURIComponent(inputValue)}`
    }
    setLoading(false)
  }

  const onFinishFailed = () => {
    setLoading(false)
  }

  const handleSearch = (search, latitude, longitude, callback) => {
    get({
      url: 'public/postal_places',
      params: { search, lat: latitude || '', long: longitude || '' },
      onSuccess: (json) => {
        const newOptions = json.map((e) => renderItem(e, search))
        setOptions(newOptions)
        if (callback) {
          callback(json)
        }
      }
    })
  }

  const onSelect = (value, option) => {
    setSelectedOption(option.extra)
  }

  const onClick = () => {
    setLoading(true)
    form.submit()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      form.submit()
    }
  }

  return (
  <div style={{ backgroundColor: Color.white }}>
    <div style={{ fontSize: '20px', textAlign: 'center', fontWeight: 'bold', margin: '1em 0' }}>
      {t('Public.Search.title')}
    </div>
    <Form
      form={form}
      name="basic"
      onFinish={onFinish}
      autoComplete="off"
      layout="inline"
      onFinishFailed={onFinishFailed}
      style={{ justifyContent: 'center' }}
    >
      <Form.Item
        style={{ width: '200px' }}
        name="search"
        rules={[{ required: true, message: t('Public.Search.required') }]}
      >
        <Space.Compact>
          <AutoComplete
            popupMatchSelectWidth={350}
            options={options}
            showSearch={{ onSearch: handleSearch }}
            onSelect={(value, option) => onSelect(value, option)}
          >
            <Input autoFocus={true} placeholder={t('Public.Search.placeholder')} onKeyDown={handleKeyDown} />
          </AutoComplete>
          <Space.Addon style={{ borderRadius: '0 10px 10px 0', backgroundColor: Color.primary, color: Color.white }}>
            <RightOutlined onClick={onClick} disabled={loading} />
          </Space.Addon>
        </Space.Compact>
      </Form.Item>
    </Form>
  </div>
  )
}
